// TCP edit (2026-10-23): remember which option the shopper changed last
// ('size' or 'other'), for setActiveMedia below. A size that turns the
// picture the other way (8x10 to 10x8, Portrait / Landscape) counts as
// 'other', since the picture changes.
if (!window.__tcpLastOptionWatch) {
  window.__tcpLastOptionWatch = true;
  const tcpOrientation = (value) => {
    const m = String(value || '').match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
    if (!m) return '';
    const w = parseFloat(m[1]);
    const h = parseFloat(m[2]);
    return w > h ? 'landscape' : w < h ? 'portrait' : 'square';
  };
  // The size showing before the click (read on press, before it changes).
  let tcpLastOrientation = '';
  const tcpRememberSize = (event) => {
    const t = event.target;
    const vs = t && t.closest && t.closest('variant-selects');
    if (!vs) return;
    const group = vs.querySelector('[data-option-name*="ize"]');
    const checked = group && group.querySelector('input:checked');
    if (checked) tcpLastOrientation = tcpOrientation(checked.value);
  };
  document.addEventListener('pointerdown', tcpRememberSize, true);
  document.addEventListener('keydown', tcpRememberSize, true);
  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!input || !input.closest || !input.closest('variant-selects')) return;
      const group = input.closest('[data-option-name]');
      const name = (group && group.dataset.optionName) || input.name || '';
      if (!/size/i.test(name)) {
        window.__tcpLastOption = 'other';
        return;
      }
      const now = tcpOrientation(input.value);
      window.__tcpLastOption = tcpLastOrientation && now && now !== tcpLastOrientation ? 'other' : 'size';
      tcpLastOrientation = now;
    },
    true
  );
}

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        // TVP edit (live frame preview): variant renders are not in the gallery
        // any more, so a variant's own media id falls back to the first slide
        // (the live viewer). Use THAT slide's id from here on, so the thumbnail
        // lookups below find its thumbnail instead of null.
        mediaId = activeMedia.dataset.mediaId;
        // TCP edit (2026-10-23): a new SIZE leaves the page where it is (the
        // picture doesn't change). Style, frame and finish changes still bring
        // the main picture into view, as Dawn does, since they change it.
        const tcpSamePicture = prepend && window.__tcpLastOption === 'size';
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail) activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            // Explicitly force an instant jump here. This container has
            // `scroll-behavior: smooth` set in CSS (component-slider.css),
            // and passing no `behavior` (or `behavior: 'auto'`) inherits
            // that CSS setting. On products with a large number of
            // variant-linked media items, a quick second selection can
            // interrupt the still-animating smooth scroll from the
            // previous one; combined with `scroll-snap-type: x mandatory`,
            // the browser can then settle on the wrong (adjacent) slide
            // instead of the one we just made active. Forcing 'instant'
            // here bypasses the CSS smooth-scroll entirely, so each
            // selection reliably lands on the correct slide regardless of
            // how quickly the next selection follows.
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'instant' });
          }
          if (tcpSamePicture) return;
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (!activeThumbnail) return;
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        // TVP edit (live frame preview): the viewer is ONE persistent slide, so
        // Dawn's `image.src = image.src` below would reload the image that is
        // already showing (a visible blink of the OLD frame) right before the
        // new one is swapped in. Announce without touching the image.
        if (activeItem.querySelector('tvp-frame-viewer')) {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
          return;
        }
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}